import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { collection, getDocs } from 'firebase/firestore';
import { signOut } from 'firebase/auth';
import { auth, db } from '../firebase';
import './ProductBrowse.css';

function ProductBrowse() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const querySnapshot = await getDocs(collection(db, 'products'));
      const prods = [];
      querySnapshot.forEach((doc) => {
        prods.push({ id: doc.id, ...doc.data() });
      });
      setProducts(prods);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching products:', error);
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const handleApply = (product) => {
    navigate('/apply-form', {
      state: {
        productId: product.id,
        productName: product.name
      }
    });
  };

  if (loading) {
    return (
      <div className="product-browse">
        <nav className="browse-nav">
          <div className="nav-container">
            <div className="logo">BetaBuyers</div>
            <button onClick={handleLogout} className="btn-logout">Sign Out</button>
          </div>
        </nav>
        <div className="browse-content">
          <div className="loading">Loading products...</div>
        </div>
      </div>
    );
  }

  return (
    <div className="product-browse">
      <nav className="browse-nav">
        <div className="nav-container">
          <div className="logo">BetaBuyers</div>
          <div className="nav-buttons">
            <button onClick={() => navigate('/dashboard')} className="btn-nav">Dashboard</button>
            <button onClick={handleLogout} className="btn-logout">Sign Out</button>
          </div>
        </div>
      </nav>

      <div className="browse-content">
        <div className="browse-header">
          <h1>Beta Testing Opportunities</h1>
          <p>Choose a product to test and submit your application</p>
        </div>

        {products.length === 0 ? (
          <div className="no-products">
            <h2>No Products Available</h2>
            <p>There are no beta testing opportunities at the moment. Check back soon!</p>
            <button onClick={() => navigate('/dashboard')} className="btn-back-dashboard">
              Back to Dashboard
            </button>
          </div>
        ) : (
          <div className="products-list">
            {products.map(product => (
              <div key={product.id} className="product-item">
                <div className="product-item-image">
                  {product.imageUrl ? (
                    <img src={product.imageUrl} alt={product.name} />
                  ) : (
                    <div className="placeholder-image">No Image</div>
                  )}
                </div>
                <div className="product-item-details">
                  {product.productLink ? (
                    <a 
                      href={product.productLink} 
                      target="_blank" 
                      rel="noopener noreferrer" 
                      className="product-item-title"
                    >
                      {product.name}
                    </a>
                  ) : (
                    <h3 className="product-item-title-plain">{product.name}</h3>
                  )}
                  <p className="product-item-description">{product.description}</p>
                  <button 
                    onClick={() => handleApply(product)}
                    className="btn-apply-item"
                  >
                    Apply to Test
                  </button>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export default ProductBrowse;